module.exports = __webpack_public_path__ + "img/泛思特营业执照-正本.d9a55c67.jpg";